export type WsDirection = 'inbound' | 'outbound';

export interface ParsedProtocolMessage {
  message: Record<string, unknown>;
  messageType: string;
}

export const parseProtocolMessage = (rawPayload: string): ParsedProtocolMessage => {
  const message = JSON.parse(rawPayload) as Record<string, unknown>;
  const messageType = Object.keys(message)[0] ?? 'unknown';
  return { message, messageType };
};

export const isSocketEpochStale = (
  expectedEpoch: number,
  socketEpoch: number,
): boolean => socketEpoch !== expectedEpoch;
